import { render, staticRenderFns } from "./rows-tab.vue?vue&type=template&id=1ebb7b1c&scoped=true"
import script from "./rows-tab.vue?vue&type=script&lang=js"
export * from "./rows-tab.vue?vue&type=script&lang=js"
import style0 from "./rows-tab.vue?vue&type=style&index=0&id=1ebb7b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebb7b1c",
  null
  
)

export default component.exports